// extracted by mini-css-extract-plugin
module.exports = {"operatorDescriptionTip":"_35zWMEWs"};